import { computed, makeObservable } from 'mobx'

import ShiftConflict, {
  TShiftConflict,
} from 'modules/shift_management/store/internal/models/ShiftConflict'

class ShiftsConflicts {
  shift_conflicts: ShiftConflict[]

  constructor(shift_conflicts: ShiftConflict[]) {
    this.shift_conflicts = shift_conflicts

    makeObservable(this, {
      shiftIds: computed,
      withLeaves: computed,
      withRestDays: computed,
      _shiftIdsSet: computed,
      _shiftIdsWithLeavesSet: computed,
      _shiftIdsWithRestDaysSet: computed,
    })
  }

  static buildFromGraphQL(conflicts: TShiftConflict[]): ShiftsConflicts {
    const conflictObjects = conflicts.map((conflict) => ShiftConflict.buildFromGraphQL(conflict))

    return new ShiftsConflicts(conflictObjects)
  }

  get shiftIds(): string[] {
    return this.shift_conflicts.map((sc) => sc.id)
  }

  get withLeaves(): ShiftConflict[] {
    return this.shift_conflicts.filter((sc) => sc.hasLeaveConflict)
  }

  get withRestDays(): ShiftConflict[] {
    return this.shift_conflicts.filter((sc) => sc.hasRestDayConflict)
  }

  get _shiftIdsSet(): Set<string> {
    return new Set(this.shiftIds)
  }

  get _shiftIdsWithLeavesSet(): Set<string> {
    return new Set(this.withLeaves.map((sc) => sc.id))
  }

  get _shiftIdsWithRestDaysSet(): Set<string> {
    return new Set(this.withRestDays.map((sc) => sc.id))
  }

  has(shiftId: string): boolean {
    return this._shiftIdsSet.has(shiftId)
  }

  hasLeaveConflictByShiftId(shiftId: string): boolean {
    return this._shiftIdsWithLeavesSet.has(shiftId)
  }

  hasRestDayConflictByShiftId(shiftId: string): boolean {
    return this._shiftIdsWithRestDaysSet.has(shiftId)
  }
}

export default ShiftsConflicts
